import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField/index";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import { v4 as uuid } from "uuid";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

const initialValues = {
  password: "",
  confirmPassword: "",
};

export default function ChangePassword(props) {
  const { onHide, id, show } = props;
  const [isError, setIsError] = useState("");
  const [values, setValues] = useState({
    newPassword: "",
    confirmPassword: "",
    showNewPassword: false,
    showRePassword: false,
  });
  const handleClickShowPassword = (key) => {
    setValues({ ...values, [key]: !values[key] });
  };
  const PasswordSchema = Yup.object().shape({
    password: Yup.string()
      .matches(/(?=.*[0-9])(?=.{8,})/, "Password must consist of a number.")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Both password need to be the same"
        ),
      })
      .matches(/(?=.*[0-9])(?=.{8,})/, "Password must consist of a number.")
      .required("Confirm Password is required"),
  });

  const onChangeUserPassword = (password, resetForm, setSubmitting) => {
    axios
      .put(
        `${process.env.REACT_APP_API_URL}humanResource/changePasswordByAdmin`,
        {
          id,
          password,
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        resetForm();
        setSubmitting(false);
        onHide(false);
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: PasswordSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onChangeUserPassword(values.password, resetForm, setSubmitting);
    },
  });

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="sm"
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="changePassword">Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="password"
                    className="w-100"
                    type={values.showNewPassword ? "text" : "password"}
                    label="New password"
                    value={values.newPassword}
                    error={getInputClasses("password")}
                    {...formik.getFieldProps("password")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="Toggle password visibility"
                            onClick={() =>
                              handleClickShowPassword("showNewPassword")
                            }
                          >
                            {values.showNewPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.password && formik.errors.password ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.password}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="confirmPassword"
                    className="w-100"
                    type={values.showRePassword ? "text" : "password"}
                    label="Confirm new password"
                    value={values.confirmPassword}
                    error={getInputClasses("confirmPassword")}
                    {...formik.getFieldProps("confirmPassword")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="Toggle password visibility"
                            onClick={() =>
                              handleClickShowPassword("showRePassword")
                            }
                          >
                            {values.showRePassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.confirmPassword &&
                formik.errors.confirmPassword ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.confirmPassword}
                    </div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false);
              formik.resetForm();
            }}
          >
            Close
          </Button>
          <Button type="submit">Save</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
